import React from 'react'
import { withStyles } from '@material-ui/core'
import { HomeHeader } from '../../account/components/HomeHeader'
import { setBrowserTabTitle } from '../../../helpers/setBrowserTabTitle'

const styles = theme => ({
  flex: {
    marginLeft: '30px',
    flex: 1,
  },
  header: {
    height: 80,
    width: '100%',
    background: theme.defaults.contrastText,
    zIndex: 2,
    position: 'fixed',
    top: 0,
    left: 0,
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    fontFamily: "'Lato', sans-serif",
  },
  headerInner: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
    justifyContent: 'flex-end',
  },
  title: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.defaults.headerText,
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '120%',
  },
  page: {
    position: 'relative',
    minHeight: '100vh',
    paddingTop: 80,
    // DESIGN.md §04: the page canvas is {colors.bg} — a flat, cool blue-gray, so
    // surfaces read as distinct from the page. No gradients, no tinted blooms.
    background: 'var(--careco-bg)',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 48px 64px',
    // DESIGN.md §08: content max width 1820px, centered.
    maxWidth: 1820,
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  // Title block: the stacked title + scope toggle on the left, the primary
  // action vertically centred against that stack on the right. The block owns
  // the space down to the summary so spacing is the same with or without a
  // cross-link.
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--careco-space-md)',
    flexWrap: 'wrap',
    marginBottom: 'var(--careco-space-xl)',
  },
  titleText: {
    minWidth: 0,
  },
  // The action ("New organisation") is pushed to the right edge; the block's
  // `align-items: center` then centres it against the title + toggle.
  actionSlot: {
    marginLeft: 'auto',
  },
  // The CareBrain / QCS scope toggle sits directly below the title, not inline
  // beside it.
  crossLinkRow: {
    display: 'flex',
    marginTop: 'var(--careco-space-md)',
  },
  // §05 page-title: 26px / 700 / 1.2. The largest text in the system.
  pageTitle: {
    margin: 0,
    fontFamily: 'var(--careco-font)',
    fontSize: 26,
    fontWeight: 700,
    lineHeight: 1.2,
    color: 'var(--careco-text-primary)',
  },
  content: {
    marginTop: 0,
  },
  '@media (max-width: 1280px)': {
    container: {
      padding: '24px 24px 48px',
    },
  },
  '@media (max-width: 991px)': {
    container: {
      padding: '16px 20px 32px',
    },
  },
  '@media (max-width: 600px)': {
    titleBlock: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 'var(--careco-space-md)',
    },
    actionSlot: {
      marginLeft: 0,
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--careco-space-sm)',
    },
    pageTitle: {
      fontSize: 22,
    },
  },
  '@global': {
    '::-webkit-scrollbar': {
      width: 12,
    },

    '::-webkit-scrollbar-track': {
      borderRadius: 3,
    },

    '::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      webkitBoxShadow: 'inset 0 0 6px rgba(24, 24, 24, 0.5)',
      backgroundColor: 'rgba(99, 99, 99, 0.2)',
    },
  },
})

class Bots extends React.Component {
  state = {}

  componentDidMount() {
    setBrowserTabTitle('Admin Panel')
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.page}>
        <HomeHeader
          title="Admin Panel"
          minimalUserMenu={this.props.minimalUserMenu}
          headerAction={this.props.headerAction}
        />
        <div className={classes.container}>
          {/*
            The title and the scope toggle stack on the left; the primary
            action sits on the right, vertically centred against that stack
            rather than pinned to the title's baseline.
          */}
          <div className={classes.titleBlock}>
            <div className={classes.titleText}>
              <h1 className={classes.pageTitle}>{this.props.title || 'Organisations'}</h1>
              {this.props.crossLink && (
                <div className={classes.crossLinkRow}>{this.props.crossLink}</div>
              )}
            </div>
            {this.props.action && <div className={classes.actionSlot}>{this.props.action}</div>}
          </div>
          {this.props.summary}
          {this.props.toolbar}
          <div className={classes.content}>{this.props.children}</div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(Bots)
